import { LinearProgress, ThemeProvider } from "@mui/material";
import React, {
  createContext,
  ReactElement,
  Suspense,
  useMemo,
  useState,
} from "react";
import themeBuilder from "styles/theme";
import routes from "routes/Routes";
import { useRoutes } from "react-router-dom";
import { useSelector } from "react-redux";
import { IAppState } from "states/RootReducer";
import "styles/App.scss";
import { ToastContainer } from "react-toastify";

export interface AppContextProps {
  landingRoute: string;
  setLandingRoute: (route: string) => void;
}

export const AppContext = createContext<AppContextProps | null>(null);

const App = (): ReactElement => {
  const [landingRoute, setLandingRoute] = useState("/dashboard");
  const appContextProvider = useMemo(
    () => ({ landingRoute, setLandingRoute }),
    [landingRoute, setLandingRoute]
  );
  const isUserLoggedIn = useSelector(
    (state: IAppState) => state.authState.isUserLoggedIn
  );
  const routing = useRoutes(routes(isUserLoggedIn));

  return (
    <ThemeProvider theme={themeBuilder()}>
      <AppContext.Provider value={appContextProvider}>
        <Suspense fallback={<LinearProgress color="primary" />}>
          {routing}
        </Suspense>
      </AppContext.Provider>
      <ToastContainer />
    </ThemeProvider>
  );
};

export default App;
